<template>
  <div class="tw-bg-true-gray-50 tw-rounded tw-p-md tw-flex tw-justify-between">
    <BannerOverviewItem :title="$t('Total payable time')">
      <template #content>
        <div class="tw-text-lg">
          <strong>
            {{ payableTimeAsDecimal }}
          </strong>
          <span
            v-if="
              !timesheetFormStore.useDayInputs &&
              timesheetFormStore.totalPayableTime &&
              payableTimeAsDecimal !== payableTimeAsMinutes
            "
          >
            {{ ` / ${payableTimeAsMinutes}` }}
          </span>
        </div>
      </template>
    </BannerOverviewItem>
    <div class="tw-flex tw-gap-md tw-items-center">
      <BannerOverviewItem :title="$t('Worker')" :content="timesheetFormStore.workerName" />
      <div class="vertical-divider tw-border-gray-200"></div>
      <BannerOverviewItem :title="$t('Submitted')" :content="timesheetFormStore.issuedAt" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { $t } from '@/composables/translation'
import { useTimesheetFormStore } from '@/components/Timesheet/store/useTimesheetFormStore'
import formatFixedDecimal from '@/components/Timesheet/utilities/formatFixedDecimal'
import convertDecimalTimeToMinuteTime from '@/components/Timesheet/utilities/convertDecimalTimeToMinuteTime'
import BannerOverviewItem from '@/components/Timesheet/BannerOverviewItem.vue'

const timesheetFormStore = useTimesheetFormStore()

const payableTimeAsDecimal = computed(
  () =>
    `${formatFixedDecimal(timesheetFormStore.totalPayableTime)}${
      timesheetFormStore.useDayInputs ? $t('d (day abbreviation)') : $t('h (hour abbreviation)')
    }`,
)
const payableTimeAsMinutes = computed(() =>
  convertDecimalTimeToMinuteTime(timesheetFormStore.totalPayableTime),
)
</script>

<style scoped lang="scss">
.vertical-divider {
  border-right: 1px solid;
  @apply tw-border-gray-300;
  @apply tw-h-1/2;
}
</style>
